// PUBLIC identity of a Provider shop -- one source of truth for the Provider Shop, its cards and headers.
//   providerOwnerName        the person ("full name ....yvox"), for administrative pages only
//   providerShopDisplayName  the shop: the shop name the Provider set, else the owner's INITIALS ("YO")
//   providerShopMonogram     the logo fallback when there is no logo image
// The backend already applies the same rule (sellerProviderCatalogService.resolveProviderShopName) and
// flags `shop.customName`; these helpers keep the UI right for any payload and never alter real names.

// "Jean Baptiste Geurrie" -> "JBG": first letter of every whitespace-separated part.
export const getNameInitials = (...parts) => parts
  .filter(Boolean).join(" ").trim().split(/\s+/).filter(Boolean)
  .map((part) => part.charAt(0).toUpperCase()).join("");

export const providerOwnerName = ({ firstname, lastname } = {}) => [firstname, lastname].filter(Boolean).join(" ").trim();

// `shop`: { shopName, customName }, `provider`: { firstname, lastname }.
export const providerShopDisplayName = (shop = {}, provider = {}) =>
  String(shop?.shopName || "").trim() || getNameInitials(provider?.firstname, provider?.lastname);

export const providerShopMonogram = (shop = {}, provider = {}) => {
  const name = providerShopDisplayName(shop, provider);
  // No shop name chosen: the display name already IS the owner's initials.
  if (shop?.customName === false) return name || getNameInitials(provider?.firstname, provider?.lastname) || "P";
  return getNameInitials(name).slice(0, 3) || "P";
};
